module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"h1":"全国の倉庫が{newline-sp}すぐに見つかる","leading":"WareXは、倉庫への一括問い合わせから{newline-pc}入出荷管理までできる倉庫利用サービスです。","search":{"btn":"検索","label":"希望エリア"},"doSignUp":{"warehouse":"無料登録して倉庫<i class=\u0027warehouse\u0027></i>を探す","price":"無料登録して倉庫料金<i class=\u0027price\u0027></i>を見る"}}}')
  delete Component.options._Ctor
}
